import { useEffect, useState, ReactNode } from 'react';

export function Skeleton({ className = '', children }: { className?: string; children?: ReactNode }) {
  return (
    <div className={`flex flex-col gap-3 ${className}`}>
      {children ?? (
        <>
          <div className="h-4 w-3/4 skeleton-text" />
          <div className="h-4 w-1/2 skeleton-text" />
          <div className="h-4 w-1/4 skeleton-text" />
        </>
      )}
    </div>
  );
}

export function SkeletonAvatar({ className = 'h-10 w-10' }: { className?: string }) {
  return <div className={`${className} rounded-full skeleton-text`} />;
}

export function SkeletonLine({ className = 'h-4 w-full' }: { className?: string }) {
  return <div className={`${className} skeleton-text`} />;
}
